const API_BASE_URL = 'https://poc.sagresrg.com.br';
const AUTH_HEADER = 'Basic 06747ce234e5ccbfec0a3bd01ec63908d5cfc6b1287f4fbc9dbccf53ac35';

async function request(path, { method = 'GET', body, isFormData = false } = {}) {
  const headers = { Authorization: AUTH_HEADER };
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers,
    body: isFormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
  });

  const data = await response.json();
  return { response, data };
}

export const apiGet = (path) => request(path);
export const apiPost = (path, body) => request(path, { method: 'POST', body });
export const apiPostForm = (path, formData) => request(path, { method: 'POST', body: formData, isFormData: true });
